import type { ReactElement } from 'react';
import { Navigate } from 'react-router';

/** 이전 수신 설정 주소로 온 회원을 통합 계정 화면으로 보낸다. */
export function MySettingsPage(): ReactElement {
  return <Navigate to="/my/account" replace />;
}
